import {
  type CellClassParams,
  type ICellRendererParams,
  type ProcessCellForExportParams,
  type ProcessRowGroupForExportParams,
  type ValueGetterParams,
} from 'ag-grid-community';
import { type ICellClassesParams } from './TableExportFormatting';

type TotalCellParams =
  | CellClassParams
  | ICellClassesParams
  | ICellRendererParams
  | ValueGetterParams
  | ProcessCellForExportParams
  | ProcessRowGroupForExportParams;

export const isTotalCell = (params: TotalCellParams) => {
  return params.node?.isRowPinned();
};

export const isSubtotalCell = (params: TotalCellParams) => {
  const isRootLevel = params.node?.level === -1;
  return Boolean(!isRootLevel && params.node?.footer);
};

export const isNormalCell = (params: TotalCellParams) => {
  return !isTotalCell(params) && !isSubtotalCell(params);
};

export const isAggregateGroupCell = (params: ICellRendererParams) => {
  return Boolean(params.node?.group && params.column?.getAggFunc());
};
